import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import AICampusFooter from '@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue';
import axios from 'axios';
import { get_headers, GET_LEAD_FORMS } from '@/utils/constants/constants';

export default {
  name: 'LeadQuestionnaire',
  components: { GlobalTable, AICampusFooter },
  data: () => ({
      headers: get_headers(),
      raw_list: [],
      table_headers: ['Form ID', 'Form Name', 'Description', 'Status'],
      table_data: [],
      lead_id: sessionStorage.getItem("lead_id"),
      total_forms: 0,
      pending_forms: 0,
      submitted_forms:0,
      lead_form_id: ''
    }),
  mounted() {
    this.fetch_shared_forms();
  },
  methods: {
    fetch_shared_forms() {
      axios
        .get(GET_LEAD_FORMS, {
          headers: this.headers,
          params: { lead_id: this.lead_id }
        })
        .then(response => {
          const payload = response.data;
          if (payload.status === 'success' && payload.data.length) {
            this.total_forms = payload.total_forms;
            this.pending_forms = payload.pending_forms;
            this.submitted_forms = payload.submitted_forms;
            this.raw_list = payload.data;
            this.build_table();
          }
        })
        .catch(err => {
          console.error('Error fetching shared forms:', err);
        });
    },
    build_table() {
      this.table_data = this.raw_list.map(item => ({
        'Form ID': item.lead_form_id,
        'Form Name': item.form_name,
        'Description': item.form_description,
        'Status': this.format_status(item.form_status)
      }));
    },
    format_status(status) {
      return status.replace(/_/g, ' ');
    },
    view_form(lead_form_id) {
      sessionStorage.setItem('lead_form_id', lead_form_id); 
      this.$router.push({
        path: '/lead_questionnaire_form',
        query: { lead_form_id }
      });
    }
  }
};